(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.property-info-tags', ['pp.widgets-templates']);

ngModule.component('ppPropertyInfoTags', {
    templateUrl: 'widgets/_angular/property-info-tags/property-info-tags.tpl.html',
    bindings: {
        property: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);